import React, { Suspense, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { PATH } from 'utils/const';
import Fallback from 'components/common/Fallback';
import Spinner from 'components/common/Spinner';
import { useAuthenticateQuery } from 'redux/services/auth/auth.slice';
import {
  loggedInSuccessfully,
  logInErrored,
} from 'redux/features/app/app.slice';
import { isValidUser } from 'utils/appUtils';
import ErrorBoundaryWithHook from 'components/ErrorBoundary/ErrorBoundary';

const Auth = React.lazy(() => import('./pages/auth'));
const Dashboard = React.lazy(() => import('./pages/dashboard'));

function Router() {
  const { data: cognitoUser, isLoading, isFetching } = useAuthenticateQuery();

  const dispatch = useDispatch();
  const { loggedIn } = useSelector((state) => state.app);
  const checkLoggedInUser = async () => {
    if (cognitoUser && isValidUser(cognitoUser)) {
      dispatch(loggedInSuccessfully(cognitoUser));
    } else {
      dispatch(logInErrored());
    }
  };

  useEffect(() => {
    checkLoggedInUser();
  }, [cognitoUser]);

  if (isLoading || isFetching) {
    return (
      <div className="app-loader-container">
        <Spinner size="4rem" color="white" isLoading />
      </div>
    );
  }
  return (
    <BrowserRouter>
      <ErrorBoundaryWithHook>
        <Suspense fallback={<Fallback />}>
          {!loggedIn ? (
            <Routes>
              <Route path="/*" element={<Auth />} />
            </Routes>
          ) : (
            <Routes>
              <Route path={`${PATH.DASHBOARD}`} element={<Dashboard />} />
              <Route path="*" element={<Dashboard />} />
            </Routes>
          )}
        </Suspense>
      </ErrorBoundaryWithHook>
    </BrowserRouter>
  );
}

export default Router;
